import { ApiDashboardSettingsResponse } from '../../../api/core/models';
import { Layout } from '../../../model/client-model/settings/board-settings/layout';
import { ClientBoardV2 } from '../model';

export function transitionElementLayoutToTransitionTargetNodes(
  dashboardSettings?: ApiDashboardSettingsResponse
): ClientBoardV2['boardSettings']['transitionTargetNodes'] {
  const showCardImages = dashboardSettings?.transitionElementShowCardImages ?? false;
  if (dashboardSettings?.transitionElementLayout === 'GRAPH_AND_BAROMETER') {
    return { layout: Layout.GRAPH_AND_BAROMETER, showCardImages };
  }
  return { layout: Layout.TARGET_AND_TEXT, showCardImages };
}
